import { render, staticRenderFns } from "./MenuTabNew.vue?vue&type=template&id=ba829dfe&scoped=true&"
import script from "./MenuTabNew.vue?vue&type=script&lang=js&"
export * from "./MenuTabNew.vue?vue&type=script&lang=js&"
import style0 from "./MenuTabNew.vue?vue&type=style&index=0&id=ba829dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba829dfe",
  null
  
)

export default component.exports